import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import {ICellEditorParams} from "ag-grid-community";
import {Ref} from "vue";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import FieldMetaData = namaTypes.FieldMetaData;

export class GridFieldWidgetUtil<T = any> extends FieldWidgetUtil {
  row: number;
  params?: ICellEditorParams;
  fieldValue: Ref<T | null | undefined>;

  constructor(presenter: WidgetsPresenter, columnMetadata: FieldMetaData, fieldValue: Ref<T | null | undefined>, row: number) {
    super(presenter, columnMetadata, true);
    this.fieldValue = fieldValue;
    this.row = row;
  }

  override fetchFieldValue(): any {
    return this.fieldValue.value;
  }

  override isGridCell(): boolean {
    return true;
  }
}
